import { render, staticRenderFns } from "./vipUsageRecords.vue?vue&type=template&id=22fcb791&"
import script from "./vipUsageRecords.vue?vue&type=script&lang=js&"
export * from "./vipUsageRecords.vue?vue&type=script&lang=js&"
import style0 from "./vipUsageRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vipUsageRecords.vue"
export default component.exports